// extracted by mini-css-extract-plugin
module.exports = {"optionLabel":"components-CompanionSelect-CompanionSelect__optionLabel--3OQyV","optionLabelText":"components-CompanionSelect-CompanionSelect__optionLabelText--15Oh3"};